"use client"

interface CareerTabsProps {
  activeTab: string
  onTabChange: (tab: string) => void
}

const tabs = ["Explore Path"]

export function CareerTabs({ activeTab, onTabChange }: CareerTabsProps) {
  return (
    <div className="flex gap-1 bg-slate-100 rounded-xl p-1">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onTabChange(tab)}
          className={`flex-1 whitespace-nowrap py-2 px-3 rounded-lg font-medium text-sm transition-all ${
            activeTab === tab
              ? "bg-white text-slate-900 shadow-sm"
              : "text-slate-500 hover:text-slate-700"
          }`}
        >
          {tab}
        </button>
      ))}
    </div>
  )
}
